import { render, staticRenderFns } from "./wy-exp-and-auto-tab-section.vue?vue&type=template&id=4bd2a54c&"
import script from "./wy-exp-and-auto-tab-section.vue?vue&type=script&lang=js&"
export * from "./wy-exp-and-auto-tab-section.vue?vue&type=script&lang=js&"
import style0 from "./wy-exp-and-auto-tab-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports